import { render } from "./DocumentReportAutovalidation.vue?vue&type=template&id=a8867972&scoped=true&ts=true"
import script from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"
export * from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"

import "./DocumentReportAutovalidation.vue?vue&type=style&index=0&id=a8867972&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8867972"]])

export default __exports__